<template>
  <div v-if="imageUrl" class="image-container" @click="handleClick">
    <img :src="imageUrl" :alt="alt || '图片'" class="display-image" />
  </div>
</template>

<script>
export default {
  name: "ImageDisplay",
  props: {
    imageUrl: {
      type: String,
      required: true,
      validator: (value) => {
        return value && value.length > 0;
      },
    },
    url: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClick() {
      if (!this.url) return;
      
      if (this.url.startsWith('http')) {
        // 外部链接跳转
        window.location.href = this.url;
      } else {
        // 内部路由跳转，直接使用完整路径
        this.$router.push(this.url);
      }
    },
  },
};
</script>

<style scoped>
.image-container {
  width: 100%;
  cursor: pointer;
}

.display-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>
